import r from "fast-deep-equal";
import { Set as u } from "immutable";
function a(e, ...t) {
  return typeof e == "function" ? e(...t) : e;
}
function l(e, t) {
  const n = { ...e };
  for (const s of t)
    delete n[s];
  return n;
}
function f(e, t) {
  const n = Array.isArray(e) ? [] : {};
  for (const s of Object.keys(e))
    n[s] = t(e[s]);
  return n;
}
function i(e) {
  return Object.keys(e);
}
function y(e) {
  return Object.values(e);
}
function p(e) {
  return Object.entries(e);
}
function j(e, t) {
  return e != null && typeof e == "object" && "equals" in e && typeof e.equals == "function" ? e.equals(t) : t != null && typeof t == "object" && "equals" in t && typeof t.equals == "function" ? t.equals(e) : r(e, t);
}
const m = [], q = {}, b = u();
export {
  y as a,
  p as b,
  q as c,
  b as d,
  l as e,
  j as i,
  a as m,
  f as o,
  m as s,
  i as t
};
//# sourceMappingURL=references-BRMYEcTr.js.map
